module.exports = __webpack_public_path__ + "static/index/img/baikal-211.8d3a151a.jpg";